import { ReactNode } from "react"
import qhistory from "qhistory"
import { createBrowserHistory  } from "history"
import { BrowserRouter } from "react-router-dom"
import { QueryClient, QueryClientProvider } from "react-query"

type QueryRouter = {
  children: ReactNode
  parse: any
  stringify: any
}

export const QueryRouter = (props: QueryRouter) => {
  const history = qhistory(createBrowserHistory(props), props.stringify, props.parse)
  const queryClient = new QueryClient()
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        {props.children}
      </QueryClientProvider>
    </BrowserRouter>
  )
}
